<nz-layout class="my-patients-table">
  @if (title) {
    <nz-header class="table-header">
      @if ((isEOC()||isInpatientView()) || isPreview || data?.length! > 0) {
        <div class="table-header-row margin-lr">
          <div class="table-header-cell">
            {{ title | translate }}
            @if (!isLoading && (((isEOC()||isInpatientView())) || isPreview) && ((this.dataGetList?.noKnown || this.dataGetList?.noInfo)
              || (this.dataGetList?.noKnown==false && this.dataGetList?.noInfo==false && this.dataGetList?.getAll==null && this.dataGetList?.getUnknown==null))) {
              <span class="margin-llr"
                >
                <div class="no-known-content">
                  <nz-switch [ngModel]="this.dataGetList?.noKnown"
                    [nzDisabled]="this.dataGetList?.isSubmitted || isPreview" [nzLoading]="isNoKnownLoading"
                  (ngModelChange)="handleToggle()"></nz-switch>
                  <div>{{"No known" | translate}}</div>
                  <div class="add-title">&nbsp;</div>
                  <div class="add-title">{{title | translate}}</div>
                </div>
              </span>
            }
          </div>
          <div class="table-header-cell margin-lrr">@if ((isEOC()||isInpatientView()) && addComponent && openModalFun && !isPreview) {
            <button nz-button nzShape="round" (click)="openModal()"
              >
              <div fxLayout="row">
                <div fxLayout="col"><mat-icon class="add-icon">add_circle_outline</mat-icon>
              </div>
              <div fxLayout="col" class="add-title">
                {{"Add" | translate}} {{title | translate}}
              </div>
            </div>
          </button>
        }
      </div>
    </div>
  }
  @if (!(isEOC()||isInpatientView()) && !isPreview && !(data?.length! > 0)) {
    <div fxLayout="row" class="table-header-row"
      >
      @if (!isLoading) {
        <div fxLayout="col" class="title">
          {{ title | translate }} - {{getUnknownText() | translate}}
        </div>
      }
    </div>
  }
</nz-header>
}
@if (((data?.length! > 0 && !this.dataGetList?.noKnown) || isLoading) && !isNoKnownLoading) {
  <nz-content>
    <ng-content></ng-content>
  </nz-content>
}
</nz-layout>

<div *ngComponentOutlet="addComponent"></div>